var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBirdProtection = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Wild-Bird-Fly-1--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Wild Bird Fly 1 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.89 8c0.08 -0.16 0.16 -0.33 0.25 -0.49C9.61 1.74 5.36 0.07 5.31 0.05a0.48 0.48 0 0 0 -0.6 0.21 8.56 8.56 0 0 0 -0.37 7A6.77 6.77 0 0 1 8.89 8Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.43 21.06a18 18 0 0 0 -3.33 -6.47c-0.13 -0.16 -1.35 -1.7 -1.49 -1.63 1.23 -0.63 4.3 -2.29 5.65 -3.87A30.43 30.43 0 0 0 23.84 2a0.49 0.49 0 0 0 -0.46 -0.69C16.28 1.27 12 4 9.63 10a19.16 19.16 0 0 0 -2.27 -1 4.43 4.43 0 0 0 -4.54 0.65 3 3 0 0 0 -2.56 1.17 0.76 0.76 0 0 0 0.15 1 0.76 0.76 0 0 0 1.05 -0.14 1.6 1.6 0 0 1 1 -0.62c3.58 6.2 9.17 10.26 14.56 10.64 0.13 0.49 0.32 1.59 0.33 1.63a0.75 0.75 0 0 0 1.48 -0.21s-0.22 -1.4 -0.4 -2.06Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBirdProtection);
export default ForwardRef;